import React from 'react';
import AntdProForm, { ProFormText, ProFormDigit } from '@ant-design/pro-form';
import { Switch } from 'antd';
import PropTypes from 'prop-types';
import ProForm from '../../layout/ProForm';

const ProjectCategoryForm = ({ onFinish, initialValues, isEdit }) => {
  const [form] = AntdProForm.useForm();
  return (
    <ProForm
      form={form}
      onFinish={onFinish}
      initialValues={initialValues}
      backPage="/system-setting/project-categories"
    >
      <ProFormText
        width="xl"
        name="name"
        label="Name"
        placeholder="name"
        rules={[
          { required: true, message: 'Please enter project category name!' },
        ]}
      />
      <ProFormText
        width="xl"
        name="workProgrammeFrom"
        label="Work Programme From"
        placeholder="work programme from"
        rules={[
          { required: true, message: 'Please enter work programme from!' },
        ]}
      />
      <ProFormText
        width="xl"
        name="workProgrammeTo"
        label="Work Programme To"
        placeholder="work programme to"
        rules={[{ required: true, message: 'Please enter work programme to!' }]}
      />
      <ProFormDigit
        label="Virement Threshold"
        name="virementThreshold"
        width="xl"
        min={0}
        max={100}
        extra="Threshold that require approval for virement, i.e. 0 need approval for all virement, 100 don't need approval for all virement"
        fieldProps={{
          precision: 0,
          formatter: (value) => `${value}%`,
        }}
        rules={[{ required: true }]}
      />
      <ProFormDigit
        width="xl"
        label="Display Sequence"
        name="seq"
        min={1}
        max={9999}
        fieldProps={{ precision: 0 }}
        rules={[{ required: true }]}
      />
      {isEdit && (
        <AntdProForm.Item name="active" label="Active" valuePropName="checked">
          <Switch />
        </AntdProForm.Item>
      )}
    </ProForm>
  );
};

ProjectCategoryForm.defaultProps = {
  initialValues: {},
  isEdit: false,
};

ProjectCategoryForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({
    name: PropTypes.string,
    workProgrammeFrom: PropTypes.string,
    workProgrammeTo: PropTypes.string,
  }).isRequired,
};

export default ProjectCategoryForm;
